import http from '../services/http';
import { typeAs } from '../services/utils';
import Str from '../services/str';

export default {
  namespaced: true,

  state: {
    videocateList: [],
    videocate: null,
    links: null,
    meta: null,
    filter: {
      keyword: '',
      tab: '',
      status: '',
    },
  },

  mutations: {
    CLEAR_ALL(state) {
      state.videocateList = [];
      state.videocate = null;
    },
    SET_VIDEOCATELIST(state, data) {
      state.videocateList = data.data.map(
        (item) => {
          item.isChecked = false;
          return item;
        },
      );
      state.links = data.links;
      state.meta = data.meta;
    },
    SET_VIDEOCATE(state, data) {
      state.videocate = data;
    },
    SET_FILTER(state, data) {
      state.filter = data;
    },
    SET_META(state, data) {
      state.meta = data;
    },
  },

  actions: {
    clear({ commit }) {
      commit('CLEAR_ALL');
    },

    setFilter({ commit }, data) {
      commit('SET_FILTER', data);
    },

    setMeta({ commit }, data) {
      commit('SET_META', data);
    },

    setVideoCate({ commit }, data) {
      commit('SET_VIDEOCATE', data);
    },

    find({ commit, state }) {
      let url = `/video-category?${Str.query(state.filter)}`;
      if (state.meta) {
        url += `&page=${state.meta.current_page}&page_count=${state.meta.per_page}`;
      }
      return http(url)
        .then((response) => {
          response.body.data.map(typeAs('videocate'));
          return response.body;
        })
        .then((response) => {
          commit('SET_VIDEOCATELIST', response);
        });
    },

    findById({ commit }, id) {
      return http(`/video-category/${id}`)
        .then((response) => response.body)
        .then(typeAs('videocate'))
        .then((item) => {
          commit('SET_VIDEOCATE', item);
        });
    },

    destroy(_, id) {
      return http(`/video-category/${id}`, { method: 'DELETE' })
        .then((response) => response.body);
    },

    save(_, {
      id, ...data
    }) {
      const request = id
        ? http(`/video-category/${id}`, { method: 'PUT', data })
        : http('/video-category', { method: 'POST', data });
      console.log(data);
      return request.then((response) => response.body);
    },

    changeStatus(_, {
      id, ...data
    }) {
      const request = http(`/video-category/${id}/status`, { method: 'PUT', data });

      return request.then((response) => response.body);
    },

    // 取得所屬問與答分類[Warranty or FAQ or RMA]
    getSupportVIDEOCates(_, id) {
      const request = id
        ? http(`/supportcatebyID/Video/${id}`)
        : http('/supportcates/Video/all');
      return request.then((response) => response.body);
    },
  },
};
